import React, { FC, useEffect, useRef, useState } from "react";
import { deserialize, serialize } from "serializr";

import { DatePicker, Modal, TreeSelect } from "antd";
import closeIcon from "../../../assets/icons/close.svg";
import './tutorForm.scss';
import ToggleSwitch from "../../../shared/components/ToggleSwitch";
import UploadLogo from "../../../shared/components/UploadLogo";
import { Formik, Form, Field } from "formik";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import InputField from "../../../shared/components/InputField";

import { convertJSONToFormData } from "../../../shared/utils/converJsonToFormData";
import DropdownField from "../../../shared/components/DropdownField";
import moment from "moment";

import CommonService from "../../../services/CommonService/common.service";
import TutorService from "../../../services/TutorService/tutor.service";

import { InstituteTutorCreateModel, InstituteTutorModel } from "../../../models/InstituteModel/tutor.model";
import { BranchClassRoomsModel, BranchMetaModel } from "../../../models/InstituteModel/branches.model";
import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";

import { InstituteTutorService } from "../../../services/InstituteService/tutor.service";
import BranchService from "../../../services/InstituteService/branch.service";
import SectionService from "../../../services/InstituteService/section.service";
import InstituteService from "../../../services/InstituteService/institute.service";

interface TutorFormProps {
    title: string;
    visible: boolean;
    setVisible: Function;
    data?: InstituteTutorModel;
    refreshList?: Function;
}

const { SHOW_PARENT } = TreeSelect;

const TutorForm: FC<TutorFormProps> = (props) => {

    const { title, visible, setVisible, data, refreshList } = props;

    const formRef = useRef<any>();

    const [institutes, setInstitutes] = useState<any>();
    const [expertise, setExpertise] = useState<any>();
    const [branches, setBranches] = useState<any>();
    const [branchClassRooms, setBranchClassRooms] = useState<BranchClassRoomsModel[]>([]);
    const [branchClassRoomsMeta, setBranchClassRoomsMeta] = useState<MetaModel[]>([]);

    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [initialValues, setInitialValues] = useState<any>({});
    const [treeOptions, setTreeOptions] = useState<any>([]);

    const fetchInstitutes = (queryParams: any) => {
        InstituteService.fetchInstitutes(
            { ...queryParams },
            (data) => {
                let meta: any = deserialize(MetaModel, data);
                setInstitutes([...meta]);
            },
            () => { },
            () => { }
        );
    };


    const fetchBranches = (instituteId: any) => {
        BranchService.fetchBranches(
            { institute_id: instituteId },
            (data) => {
                let meta: any = deserialize(BranchMetaModel, data);
                setBranches([...meta]);
            },
            () => { },
            () => { }
        );
    };


    const fetchClassRooms = (id: any) => {
        SectionService.fetchBranchClassRooms(
            { branch_id: id },
            (classrooms: BranchClassRoomsModel[]) => {
                const meta = deserialize(MetaModel, classrooms) as MetaModel[];
                setBranchClassRoomsMeta(meta);
                setBranchClassRooms(classrooms);
                const options = classrooms.map((classroom) => ({
                    title: classroom.name,
                    value: classroom.id,
                    key: classroom.id,
                    type: "classroom",
                    children: classroom?.sections?.map((section) => ({
                        title: section.name,
                        value: classroom.id + "-" + section.id,
                        key: classroom.id + "-" + section.id,
                        type: "section",
                        children: section?.sectionSubjects?.map((subject) => ({
                            title: subject.name,
                            value: classroom.id + "-" + section.id + "-" + subject.id,
                            key: classroom.id + "-" + section.id + "-" + subject.id,
                            type: "subject",
                        })),
                    })),
                }));
                setExpertise(options);
            },
            () => { },
            () => { }
        );
    };

    useEffect(() => {
        if (data?.institute?.id) {
            fetchBranches(data?.institute?.id);
        }
        if (data?.branch?.id) {
            fetchClassRooms(data?.branch?.id);
          }
        setInitialValues({
            fullName: data?.fullName,
            phoneNumber: data?.phoneNumber,
            email: data?.email,
            instituteId: data?.institute?.id,
            branchId: data?.branch?.id,
            expertise: data?.tutorClassRooms?.flatMap((classroom) => {
                return classroom?.tutorSections?.flatMap((section) => {
                    return section?.tutorSubjects?.flatMap((subject) => {
                        return classroom?.id + "-" + section?.id + "-" + subject?.id;
                    });
                });
            }),
            branchClassRoomId: data?.tutorClassRooms?.filter(
                (data) => data?.classTeacher
            )?.[0]?.id,
            isActive: data ? data?.isActive : true,
            displayPictureUrl: data?.displayPictureUrl,
        });
    }, [data])

    // console.log(data);


    useEffect(() => {
        fetchInstitutes({});
    }, [])



    const handleClose = () => {
        setVisible(false);
        formRef.current.resetForm(initialValues)
    }

    const handleSubmit = (values: any) => {
        setButtonLoading(true);
        //if class is selected (1), traverse through sections and return all subjects
        //if section is selected (1-1), match classroom-section and return subjects
        //if subject is selected (1-1-1), match classroom-section-subject and return

        const sectionSubjects = values?.expertise?.flatMap((value) => {
            return branchClassRooms?.flatMap((classroom) => {
                if (
                    classroom?.sections?.length &&
                    ((Number.isInteger(value) && classroom?.id == value) ||
                        (!Number.isInteger(value) &&
                            classroom?.id == value?.split("-")?.[0]))
                ) {
                    return classroom?.sections?.flatMap((section) => {
                        if (
                            section?.sectionSubjects?.length &&
                            (Number.isInteger(value) || section?.id == value?.split("-")?.[1])
                        ) {
                            return section?.sectionSubjects?.flatMap((subject) => {
                                if (
                                    Number?.isInteger(value) ||
                                    subject?.id == value?.split("-")?.[2] ||
                                    value?.split("-")?.length == 2
                                ) {
                                    return subject?.id;
                                }
                            });
                        }
                    });
                }
            });
        });

        const jsonPayload = serialize(InstituteTutorCreateModel, {
            ...values,
            expertise: sectionSubjects?.filter((data) => data),
        });
        if (values?.displayPicture) {
            jsonPayload["display_picture"] = values?.displayPicture;
        }
        if (!values?.branchClassRoomId) {
            delete jsonPayload["branch_class_rooms"]
        }
        const formDataPayload = convertJSONToFormData({ tutor: jsonPayload }, true);
        if (data?.id) {
            InstituteTutorService.updateInstituteTutor(
                data?.id,
                formDataPayload,
                () => {
                    if (refreshList) refreshList(1)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                () => { },
                () => {
                    setButtonLoading(false);
                }
            );
        } else {
            InstituteTutorService.createInstituteTutor(
                formDataPayload,
                () => {
                    if (refreshList) refreshList(1)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                () => { },
                () => {
                    setButtonLoading(false);
                }
            );
        }
    };

    return (
        <Modal title={null}
            centered
            visible={visible}
            onCancel={handleClose}
            footer={null}
            className='board-form__modal tutor-form__modal'
            closeIcon={<img src={closeIcon} alt='' />}
        >
            <Formik initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize
                innerRef={formRef}
            >{({ setFieldValue, values, resetForm }) => {
                return (
                    <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div className='board-form__header'>
                            <div className='board-form__title'>{title}</div>
                            <div className='board-form__toggle'>
                                <Field name="isActive" as='switch'>
                                    <ToggleSwitch checked={values.isActive}
                                        handleChange={() => {
                                            setFieldValue('isActive', !values.isActive)
                                        }}
                                    />
                                </Field>
                            </div>
                        </div>

                        <Field name="displayPicture" as='file-upload'>
                            <UploadLogo logoUrl={values?.displayPicture ?
                                values?.displayPicture : data?.displayPictureUrl}
                                setFile={setFieldValue}
                                uploadText='Upload photo'
                            />
                        </Field>

                        <div className="board-form__input">
                            <div className='board-form__label'>Teacher Name</div>
                            <InputField type="text" name="fullName" placeholder="Enter" />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Phone Number</div>
                            <InputField type="text" name="phoneNumber" placeholder="Type phone number" prefix={"+91"} />
                        </div>


                        <div className="board-form__input">
                            <div className='board-form__label'>Email</div>
                            <InputField type="text" name="email" placeholder="Type email address" />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Institute</div>
                            <DropdownField
                                name="instituteId"
                                placeholder="Select"
                                options={institutes}
                                value={values?.instituteId}
                                onChange={(value) => {
                                    setFieldValue("instituteId", value);
                                    setFieldValue("branchId", null);
                                    setFieldValue("expertise", undefined);
                                    fetchBranches(value);
                                }}
                                showSearch={false}
                                optionFilterProp="label"
                            />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Branch</div>
                            <DropdownField
                                name="branchId"
                                placeholder="Select"
                                options={branches}
                                value={values?.branchId}
                                onChange={(value) => {
                                    setFieldValue("branchId", value);
                                    setFieldValue("expertise", undefined);
                                    fetchClassRooms(value);
                                }}
                                showSearch={false}
                                optionFilterProp="label"
                            />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Expertise</div>
                            <Field as="tree-select" name="expertise">
                                <TreeSelect
                                    style={{ width: "100%" }}
                                    value={values?.expertise}
                                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                                    treeData={expertise}
                                    placeholder="Search"
                                    allowClear
                                    multiple
                                    treeCheckable={true}
                                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                                    onChange={(value) => {
                                        setFieldValue("expertise", value);
                                        console.log(value);
                                    }}
                                />
                            </Field>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Class Teacher</div>
                            <DropdownField
                                name="branchClassRoomId"
                                placeholder="Select"
                                options={branchClassRoomsMeta}
                                value={values?.branchClassRoomId}
                                onChange={(value) => {
                                    setFieldValue("branchClassRoomId", value);
                                }}
                                showSearch={false}
                                optionFilterProp="label"
                            />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Password</div>
                            <InputField type="text" name="password" placeholder="Password" />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Confirm Password</div>
                            <InputField type="text" name="confirmPassword" placeholder="Confirm password" />
                        </div>

                        <div className='board-form__action'>
                            <div className='board-form__button' onClick={() => {
                                handleClose();
                                resetForm({})
                            }}>
                                <ButtonComponent buttonContent='Cancel'
                                    type='text'
                                />
                            </div>
                            <div className='board-form__button'>
                                <ButtonComponent buttonContent={data ? 'Update' : 'Create'}
                                    type='primary'
                                    htmlType='submit'
                                    loading={buttonLoading}
                                />
                            </div>
                        </div>
                    </Form>
                )
            }}
            </Formik>
        </Modal>
    )
}

export default TutorForm;
